import escapeHtml from 'escape-html';
import { Node, Text } from 'slate';

export const Tokens = {
    USER_NAME: '{{USER_NAME}}',
    ORGANIZATION_NAME: '{{ORGANIZATION_NAME}}',
};

export default (
    richText: Node[],
    tokens: { userName?: string; organizationName?: string } = {}
) => {
    if (richText == null) {
        return richText;
    }

    const editor = {
        children: richText,
    };

    const html = toHtml(editor);

    const { userName, organizationName } = tokens;
    const tokenizedHtml = html
        .split(Tokens.USER_NAME)
        .join(userName || Tokens.USER_NAME)
        .split(Tokens.ORGANIZATION_NAME)
        .join(organizationName || Tokens.ORGANIZATION_NAME);

    return tokenizedHtml;
};

const toHtml = (node): string => {
    if (Text.isText(node)) {
        let text = escapeHtml(node.text);
        if (node.bold) {
            text = `<strong>${text}</strong>`;
        }
        if (node.italic) {
            text = `<em>${text}</em>`;
        }
        if (node.underline) {
            text = `<u>${text}</u>`;
        }

        return `<span>${text}</span>`;
    }

    const children = node.children.map((n) => toHtml(n)).join('');

    switch (node.type) {
        case 'paragraph':
            return `<div>${children}<br/></div>`;
        case 'bulleted-list':
            return `<ul>${children}</ul>`;
        case 'numbered-list':
            return `<ol>${children}</ol>`;
        case 'list-item':
            return `<li>${children}</li>`;
        case 'link':
            return `<a href="${escapeHtml(node[node.type])}" target="_blank">${children}</a>`;
        case 'email':
            return `<a href="mailto:${escapeHtml(node[node.type])}">${children}</a>`;
        case 'token':
            return `<span>${children}</span>`;

        default:
            return children;
    }
};
